import { FilterConfig, Filters, SavedFilter, SavedFilters } from '../../types';

export const getPayloadUpdateStorage = ({
  newFilters,
  config,
  savedFilters,
}: {
  newFilters: {
    name: string;
    filters: Filters;
  };
  config: FilterConfig | null;
  savedFilters: SavedFilters;
}) => {
  const savedFiltersExeptNew = savedFilters.filter(
    (filter) => filter.name !== newFilters.name
  );

  const newFiltersData = [
    ...savedFiltersExeptNew,
    {
      name: newFilters.name,
      filtersJsonString: JSON.stringify(newFilters.filters),
    },
  ];

  return {
    storage_key: config!.id,
    data: newFiltersData,
  };
};

export const getPayloadDeleteFiltersUpdateStorage = ({
  config,
  savedFilters,
  deleteSavedFilters,
}: {
  config: FilterConfig | null;
  savedFilters: SavedFilters;
  deleteSavedFilters: SavedFilter;
}) => {
  const savedFiltersExeptDeleted = savedFilters.filter(
    (filter) => filter.name !== deleteSavedFilters.name
  );

  return {
    storage_key: config!.id,
    data: savedFiltersExeptDeleted,
  };
};
